export default __webpack_public_path__ + "static/media/1926.09d4033f.png";